import React from 'react'

import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';
import Layout from '../../components/web/Layout';
import BreadCrump from '../../components/web/breadcrump/BreadCrump';
import Container from '../../components/ui/container/Container';
import { Helmet } from 'react-helmet';
import { apiUrl } from '../../utils/helper';
function PageContent() {
  const { label } = useParams();
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


const fetchPage = async () => {
  setLoading(true);
  setError(null);  
  const apiUrle= apiUrl
  try {
    const res = await axios.get(`${apiUrle}page/${label}`);
    setPageData(res.data);
  } catch (err) {
    setError('Page not found');
    setPageData(null);
  } finally {
    setLoading(false);
  }
};


  useEffect(() => {
    fetchPage();
  },[label]);

  if (loading) {
    return (
      <div className="max-w-3xl mx-auto p-4 space-y-4">
        <div className="h-8 w-3/4 bg-gray-300 rounded animate-pulse" />
        <div className="h-4 w-1/2 bg-gray-200 rounded animate-pulse" />
        <div className="space-y-2">
          <div className="h-4 w-full bg-gray-200 rounded animate-pulse" />
          <div className="h-4 w-5/6 bg-gray-200 rounded animate-pulse" />
          <div className="h-4 w-4/5 bg-gray-200 rounded animate-pulse" />
        </div>
      </div>
    );
  }

  if (error) return (<>
    <Layout>
      <BreadCrump />
      <div className="text-red-500 text-center mt-10"> {error}</div>;
    </Layout>

  </>)

  return (
    <Layout>
      <Helmet> {pageData.title} </Helmet>
      <BreadCrump />
      <Container>
        <div className="mx-auto p-4">
          <h1 className="text-2xl font-bold mb-4">{pageData.title}</h1>
          <div dangerouslySetInnerHTML={{ __html: pageData.description }} />
        </div>
      </Container>
    </Layout>
  );
}

export default PageContent

